"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConversationFilterSortColumnEnum = void 0;
var ConversationFilterSortColumnEnum;
(function (ConversationFilterSortColumnEnum) {
    ConversationFilterSortColumnEnum["CreatedAt"] = "created_at";
    ConversationFilterSortColumnEnum["LastMessageAt"] = "last_message_at";
    ConversationFilterSortColumnEnum["LastOutboundMessageAt"] = "last_inbound_message_at";
    ConversationFilterSortColumnEnum["LastInboundMessageAt"] = "last_outbound_message_at";
    ConversationFilterSortColumnEnum["ResolutionTime"] = "resolution_time";
    ConversationFilterSortColumnEnum["ResponseTime"] = "response_time";
    ConversationFilterSortColumnEnum["StatusAt"] = "status_at";
    ConversationFilterSortColumnEnum["AssignedAt"] = "assigned_at";
    ConversationFilterSortColumnEnum["FirstAssignedAt"] = "first_assigned_at";
})(ConversationFilterSortColumnEnum = exports.ConversationFilterSortColumnEnum || (exports.ConversationFilterSortColumnEnum = {}));
